(function (global, $) {

    $("footer span").text($("footer span").text().replace("- IJK -", "- IJK Outsourcing -"))

    $(document).on('change', "input[date]", function () {
        let value = $(this).val();
        if (value) {
            // First normalize the input string to support multiple input types
            let dateString = value.replace(/ /g, '-').replace(/[/]/g, '-');
            let dateArray = dateString.split('-');

            let date = new Date(dateArray[2] ?? 0, dateArray[1] - 1 ?? 0, dateArray[0] ?? 0);
            $(this).val([
                date.getDate().toString().padStart(2, '0'),
                (date.getMonth() + 1).toString().padStart(2, '0'),
                date.getFullYear().toString().padStart(4, '0')].join('-'));
        } else {
            $(this).val(null);
        }
    });

    $(document).on('change', "input[datetime]", function () {
        let value = $(this).val();
        if (value) {
            // First normalize the input string to support multiple input types
            let dateString = value.replace(/ /g, '-').replace(/[/]/g, '-').replace(/:/g, '-');
            let dateArray = dateString.split('-');

            let date = new Date(dateArray[2] ?? 0, dateArray[1] - 1 ?? 0, dateArray[0] ?? 0, dateArray[3] ?? 0, dateArray[4] ?? 0);
            $(this).val([
                    date.getDate().toString().padStart(2, '0'),
                    (date.getMonth() + 1).toString().padStart(2, '0'),
                    date.getFullYear().toString().padStart(4, '0')].join('-')
                + " " +
                [date.getHours().toString().padStart(2, '0'),
                    date.getMinutes().toString().padStart(2, '0')].join(':'));
        }
        else {
            $(this).val(null);
        }
    })

    global.InitTextAreaCharacterLimitCounter = function () {
        $("textarea[data-val-length-max]").each(function () {
            let characterLimit = parseInt($(this).attr("data-val-length-max"));
            let currentLength = $(this).val().length;

            let counter = $(`<span class='text-black-50'>(${currentLength} / ${characterLimit})</span>`).insertAfter($(this));

            $(this).on("keyup", function () {
                let current = $(this).val().length;
                counter.text("(" + current + " / " + characterLimit + ")");
            });
        });
    }

    global.EnableJQueryValidatorLocalized = function () {
        $.validator.methods.range = function (value, element, param) {
            var globalizedValue = value.replace(",", ".");
            return this.optional(element) || (globalizedValue >= param[0] && globalizedValue <= param[1]);
        }

        $.validator.methods.number = function (value, element) {
            return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:[\s\.,]\d{3})+)(?:[\.,]\d+)?$/.test(value);
        }
    }

}(window.global = window.global || {}, $));

$(function () {
    globalCore.EnablePopOver();
});
